module.exports = __webpack_public_path__ + "fonts/trust_sans_black_it-webfont.07093a2c.woff";